import { TypeArticle } from '~/types/contentful'

const addToLastGroup = (
  acc: Array<
    | TypeArticle<'WITHOUT_UNRESOLVABLE_LINKS', string>[]
    | TypeArticle<'WITHOUT_UNRESOLVABLE_LINKS', string>
  >,
  item: TypeArticle<'WITHOUT_UNRESOLVABLE_LINKS', string>,
) => {
  const groupIndex = acc.length - 1
  const groupArray = acc[groupIndex]
  if (Array.isArray(groupArray)) {
    groupArray.push(item)
  }
}

/**
 * Performs grouping of posts by pattern 1, [4], 1, [4 or 5]
 * Useful for displayng list of resources.
 *
 * @example
 * groupPosts([Post1, Post2, Post3, Post4, Post5, Post6, Post7]) // [Post1, [Post2, Post3, Post4, Post5], Post6, [Post7]]
 * groupPosts([Post1, Post2, Post3, Post4, Post5, Post6]) // [Post1, [Post2, Post3, Post4, Post5, Post6]]
 */
export const groupPosts = (posts?: TypeArticle<'WITHOUT_UNRESOLVABLE_LINKS', string>[]) => {
  if (!posts || !posts.length) return []

  return posts.reduce(
    (acc, item, i) => {
      if (i % 5 === 0) {
        if (i !== posts.length - 1) {
          acc.push(item, [])
        } else {
          addToLastGroup(acc, item)
        }
      } else {
        addToLastGroup(acc, item)
      }
      return acc
    },
    [] as Array<
      | TypeArticle<'WITHOUT_UNRESOLVABLE_LINKS', string>[]
      | TypeArticle<'WITHOUT_UNRESOLVABLE_LINKS', string>
    >,
  )
}

export const categoryGroupPosts = (posts: TypeArticle<'WITHOUT_UNRESOLVABLE_LINKS', string>[]) => {
  if (!posts || !posts.length) return []

  const firstGroup = posts.slice(0, 4)
  const restPosts = groupPosts(posts.slice(4))

  return [firstGroup, ...restPosts]
}
